var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector-3735-stroke__Vector 3735 (Stroke)",
    fill: "#454F5B",
    d: "M13.918 12.412a.247.247 0 0 0-.247-.247H5.743a.247.247 0 0 0-.246.247v5.897h8.42V12.41Zm-1.58-9.098a.74.74 0 1 1 0 1.478H6.455a.74.74 0 0 1 0-1.478h5.881ZM0 1.724C0 .773.772 0 1.725 0h12.53c.451 0 .885.178 1.208.494l3.725 3.652c.33.325.516.77.516 1.232v12.684c0 .953-.772 1.725-1.724 1.725H1.725A1.725 1.725 0 0 1 0 18.062V1.725Zm1.478 16.338c0 .136.11.247.247.247h2.293V12.41c0-.952.773-1.724 1.725-1.724h7.928c.953 0 1.725.772 1.725 1.725v5.897h2.584c.136 0 .246-.11.246-.247V5.378a.247.247 0 0 0-.073-.176L14.427 1.55a.246.246 0 0 0-.172-.07H1.725a.246.246 0 0 0-.247.246v16.337Z",
    className: "vector-3735-stroke__Vector vector-3735-stroke__3735 vector-3735-stroke__(Stroke)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.39c027befb73123724eb7d39ec5dcc66.svg";
export { ForwardRef as ReactComponent };